/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useForm } from 'react-hook-form';
import { useAuthStore } from '../../../store/AuthContext';
import { PriceFormatter } from '../../../utils/PriceFormatter';
import { TarjetaOroHelper } from '../../TarjetasOro/TarjetaOroHelper';
import { TarjetasOroConstants } from '../../TarjetasOro/TarjetasOroConstants';
import IconBack from '../../../Icons/IconBack';

interface Props {
  visible: boolean;
  setVisible: (visible: boolean) => void;
}

const CalculadoraForm: FC<Props> = (props) => {
  const { visible, setVisible } = props;
  const dataUser = useAuthStore();
  const [isCuotaAlta, setIsCuotaAlta] = useState<boolean>(false);
  const { moneda } = dataUser.user;
  const [ahorro, setAhorro] = useState<number>(0);
  const {
    register,
    reset,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: 'onChange',
  });
  const { t } = useTranslation();

  const submitForm = () => {
    setAhorro(TarjetaOroHelper.getSavingCalculated(isCuotaAlta));
    TarjetaOroHelper.showResultadoCalculadora();
  };

  const setCuotaChanged = (isBaja: boolean) => {
    TarjetaOroHelper.hideResultadoCalculadora();
    setIsCuotaAlta(isBaja);
  };

  const priceFormatter = (value: any) => {
    const monedaText = moneda === 'euro' ? t('euro') : t('cc');
    return PriceFormatter.formatStringAsPrice(value as string, monedaText);
  };

  const handleChangeGasto = () => {
    TarjetaOroHelper.hideResultadoCalculadora();
  };

  const goBack = () => {
    TarjetaOroHelper.resetForm(TarjetasOroConstants.FORM_GASTO);
    reset();
    TarjetaOroHelper.hideResultadoCalculadora();
    setVisible(false);
    document.body.classList.remove('fix');
  };

  //* *** Save with Enter key
  const saveInfo = (e) => {
    if (e.key === 'Enter' && e.keyCode === 13) {
      e.preventDefault();
      e.stopPropagation();
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      document.getElementById('calculator-btn').click();
      setVisible(false);
    }
  };
  useEffect(() => {
    const element = document.getElementById('section') as HTMLElement;
    if (visible) {
      element.setAttribute('tabindex', '0');
      element.focus();
      element.addEventListener('keydown', saveInfo, false);
    } else {
      element.removeEventListener('keydown', saveInfo, false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible]);

  return (
    <>
      <section
        id="section"
        className={`o-section--large form-calculadora bloque-form tarjetas ${
          visible ? 'visible' : ''
        }`}
      >
        <div className="container">
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid,jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
          <a
            className="link-prev"
            onClick={() => {
              goBack();
            }}
          >
            <div className="icon icon-medium">
              <IconBack />
            </div>
            <p className="u-font-normal u-text-brand u-margin-left">
              {t('tarjetas.tarjeta-oro-datos.back')}
            </p>
          </a>

          <form
            id="form-gasto"
            onSubmit={handleSubmit(() => {
              submitForm();
            })}
            className="form-datos"
            noValidate
          >
            <div className="row u-justify-content-center u-margin-bottom">
              <div className="col-12 col-md-6">
                <div className="form-group u-margin-bottom">
                  {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                  <label htmlFor="gasto" className="control-label">
                    {t('tarjetas.tarjeta-oro-datos.month-expence')}
                  </label>
                  <div className="form-control-block u-margin-bottom">
                    <input
                      type="text"
                      className={`form-control ${errors.gasto ? 'error' : ''}`}
                      id="gasto"
                      {...register('gasto', {
                        required: true,
                        pattern: /^[0-9]*$/i,
                      })}
                      onChange={handleChangeGasto}
                    />
                    {errors.gasto && errors.gasto.type === 'pattern' && (
                      // eslint-disable-next-line jsx-a11y/label-has-associated-control
                      <label id="gasto-error" className="error" htmlFor="gasto">
                        {t('validaciones.not-valid-value')}
                      </label>
                    )}
                    {errors.gasto && errors.gasto.type === 'required' && (
                      // eslint-disable-next-line jsx-a11y/label-has-associated-control
                      <label id="gasto-error" className="error" htmlFor="gasto">
                        {t('validaciones.empty-value')}
                      </label>
                    )}
                  </div>
                  <div className="form-group u-margin-bottom-large">
                    {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                    <label htmlFor="cuenta" className="control-label">
                      {t('tarjetas.tarjeta-oro-datos.choose-fee')}
                    </label>

                    <div className="tabs-block__selector">
                      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid,jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
                      <a
                        className={`tabs-block__selector-item ${
                          !isCuotaAlta ? 'active' : ''
                        }`}
                        onClick={() => setCuotaChanged(false)}
                      >
                        {TarjetasOroConstants.CUATRO_POR_CIENTO}
                      </a>
                      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid,jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
                      <a
                        className={`tabs-block__selector-item ${
                          isCuotaAlta ? 'active' : ''
                        }`}
                        onClick={() => setCuotaChanged(true)}
                      >
                        {TarjetasOroConstants.SEIS_POR_CIENTO}
                      </a>
                    </div>
                    <div
                      className={`tabs-block__cuota ${
                        !isCuotaAlta ? 'active' : ''
                      }`}
                    >
                      {`${priceFormatter(TarjetasOroConstants.CUOTA_BAJA)} ${t(
                        'tarjetas.hazte-oro.cuota-al-mes',
                      )}`}
                    </div>
                    <div
                      className={`tabs-block__cuota ${
                        isCuotaAlta ? 'active' : ''
                      }`}
                    >
                      {`${priceFormatter(TarjetasOroConstants.CUOTA_ALTA)} ${t(
                        'tarjetas.hazte-oro.cuota-al-mes',
                      )}`}
                    </div>
                  </div>

                  <div className="u-text-center">
                    <button
                      id="calculator-btn"
                      type="submit"
                      className="btn btn-oro"
                    >
                      {t('tarjetas.tarjeta-oro-datos.calc')}
                    </button>
                  </div>

                  <div className="calculadora-resultado hide">
                    <span>{t('tarjetas.tarjeta-oro-datos.year-saving')}</span>
                    <span className="importe">
                      {ahorro && ahorro > 0
                        ? priceFormatter(ahorro)
                        : t('tarjetas.tarjeta-oro-datos.ups')}
                    </span>
                    <input id="importe-value" type="hidden" value={ahorro} />
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </section>
    </>
  );
};

export default CalculadoraForm;
